var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sort",on:{"click":function($event){return _vm.sortAction()}}},[(_vm.sortAttr.includes('sort'))?_c('i',{staticClass:"el-icon-caret-bottom"}):_c('i',{staticClass:"el-icon-caret-top"})])
}
var staticRenderFns = []

export { render, staticRenderFns }